var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.memoria)?_c('div',{class:['memoria-container']},[(_vm.titulo)?_c('label',[_vm._v(_vm._s(_vm.titulo))]):_vm._e(),_c('p',{class:[{ negrito: _vm.negrito }],domProps:{"innerHTML":_vm._s(_vm.memoria)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }